'use strict';

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/.1.5.2@rc-switch/lib/index.js
// module id = 438
// module chunks = 0 1